// extracted by mini-css-extract-plugin
export var addViewLink = "_15-1";
export var availabilityIcon = "_15-16";
export var availabilitySelectionIcon = "_15-15";
export var backButton = "_15-2";
export var backIcon = "_15-z";
export var conversationCount = "_15-3";
export var dragHandle = "_15-5";
export var dropdown = "_15-e";
export var dropdownIcon = "_15-7";
export var dropdownOption = "_15-6";
export var dropdownTriangle = "_15-d";
export var expand = "_15-f";
export var folder = "_15-i";
export var folderItem = "_15-c";
export var icon = "_15-8";
export var iconRow = "_15-9";
export var image = "_15-a";
export var logo = "_15-b";
export var navContainer = "_15-h";
export var navigationFooter = "_15-g";
export var pageShell = "_15-0";
export var placeholderAvailable = "_15-11";
export var placeholderBox = "_15-14";
export var placeholderBusy = "_15-13";
export var placeholderUnavailable = "_15-12";
export var profile = "_15-k";
export var profileContainer = "_15-m";
export var profileDropdown = "_15-n";
export var profileImage = "_15-l";
export var profileMain = "_15-o";
export var profileSubtitle = "_15-q";
export var profileTitle = "_15-p";
export var reorderIcon = "_15-r";
export var sentLine = "_15-u";
export var settingsHeader = "_15-s";
export var sidenavTextColor = "_15-y";
export var spamLine = "_15-t";
export var subitemWithTag = "_15-4";
export var supportItems = "_15-j";
export var teamText = "_15-10";
export var viewLine = "_15-x";
export var viewLineButton = "_15-w";
export var viewLineButtons = "_15-v";